import { useUnit } from 'effector-react';
import clsx from 'clsx';
import { $profileFeatureStore } from '@lib/store/profile';
import type { AccountResponse } from '@shared/api/rest/accounts';
import type { CardResponse } from '@shared/api/rest/cards';
import { UserType } from '@shared/api/rest/users';
import { UserLongInfoItem } from './userLongInfoItem';
import { Icon } from '@shared/widgets';
import AccountIcon from '@assets/icons/account.svg';
import CardIcon from '@assets/icons/card.svg';

interface IUserLongInfoProps {
  type: UserType;
  locked: boolean;
  open: boolean;
  userId: string;
  accounts: AccountResponse[];
  cards: CardResponse[];
  openAddCard: () => void;
  openAddAccount: () => void;
  removeAccount: (id: number) => void;
  removeCard: (id: number) => void;
}

export const UserLongInfo = (props: IUserLongInfoProps) => {
  const profileFeatureStore = useUnit($profileFeatureStore.store);

  if (props.type === UserType.ADMIN || !profileFeatureStore.data?.userManagement.managerAccountsOrCardsPermissions) return null;

  return (
    <div className={clsx(props.locked && 'opacity-50 select-none pointer-events-none')}>
      {props.type === UserType.MANAGER && (
        <UserLongInfoItem
          show={props.open}
          type={UserType.MANAGER}
          userId={props.userId}
          accounts={props.accounts}
          removeItem={props.removeAccount}
          icon={<Icon icon={<AccountIcon />} color='secondary-inverse' />}
          showAddModal={props.openAddAccount}
        />
      )}
      {props.type === UserType.USER && (
        <UserLongInfoItem
          show={props.open}
          type={UserType.USER}
          userId={props.userId}
          cards={props.cards}
          removeItem={props.removeCard}
          icon={<Icon icon={<CardIcon />} color='secondary-inverse' />}
          showAddModal={props.openAddCard}
        />
      )}
    </div>
  );
};
